import type { BottomSheetContentWrapper as BottomSheetContentWrapperType } from './types';
// @ts-ignore
import { default as BottomSheetContentWrapper } from './BottomSheetContentWrapper';
export default BottomSheetContentWrapper as BottomSheetContentWrapperType;
